import { render, staticRenderFns } from "./TablaPivotListaPrecio.vue?vue&type=template&id=8b8e43aa"
import script from "./TablaPivotListaPrecio.vue?vue&type=script&lang=js"
export * from "./TablaPivotListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports